var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2792_9145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    rx: 98,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 171.5C36.75 137.673 64.1725 110.25 98 110.25C131.827 110.25 159.25 137.673 159.25 171.5M126.583 57.1668C126.583 72.953 113.786 85.7502 98 85.7502C82.2138 85.7502 69.4167 72.953 69.4167 57.1668C69.4167 41.3807 82.2138 28.5835 98 28.5835C113.786 28.5835 126.583 41.3807 126.583 57.1668Z",
    fill: "#C0BBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 171.5C36.75 137.673 64.1725 110.25 98 110.25C131.827 110.25 159.25 137.673 159.25 171.5L133 186L117 190.5L98 194L77 190L63.5 186L54 181L36.75 171.5Z",
    fill: "#C0BBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 171.5C36.75 137.673 64.1725 110.25 98 110.25C131.827 110.25 159.25 137.673 159.25 171.5L133 186L117 190.5L98 194L77 190L63.5 186L54 181L36.75 171.5ZM126.583 57.1668C126.583 72.953 113.786 85.7502 98 85.7502C82.2138 85.7502 69.4167 72.953 69.4167 57.1668C69.4167 41.3807 82.2138 28.5835 98 28.5835C113.786 28.5835 126.583 41.3807 126.583 57.1668Z",
    stroke: "#C0BBC7",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2792_9145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    rx: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarcard);
export default __webpack_public_path__ + "static/media/Avatar card.18f51c135ae4f6205eae3b47bf556673.svg";
export { ForwardRef as ReactComponent };